export const LANGUAGES_SUPPORTED = {
    Japanese: 'ja',
    English: 'en',
    Vietnamese: 'vi'
} as const;

export type LanguagesSupported = (typeof LANGUAGES_SUPPORTED)[keyof typeof LANGUAGES_SUPPORTED];

export const STATUS = {
    Inactive: 0,
    Active: 1,
    WaitConfirm: 2
} as const;

export type Status = (typeof STATUS)[keyof typeof STATUS];

export const GENDER = {
    Male: 0,
    Female: 1
} as const;

export type Gender = (typeof GENDER)[keyof typeof GENDER];

export const STATUS_TYPE = {
    INACTIVE: 0,
    ACTIVE: 1
} as const;

export type StatusType = (typeof STATUS_TYPE)[keyof typeof STATUS_TYPE];

// MEO landmark ads (2026-04-30) で BUSINESS=2 を backend (Constants.ROLE.BUSINESS) に追加済。
// CMS フロント側にも対称形で追加 (= ユーザー管理「事業者」タブ / role 変更 UI で利用)。
export const ROLE = {
    ADMIN: 0,
    END_USER: 1,
    BUSINESS: 2
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];

// 数値は backend (items.item_type SMALLINT) と同期。
// spec design/meo-landmark-ads-spec.md §データモデル §items テーブル拡張:
//   0 = PERSONAL (= NOT_SET、個人ユーザのアイテム)
//   1 = COMMERCIAL_POSTCARD (= COUPON、紅型ポストカード型おみくじ)
//   2 = TOURIST_INFO (Phase 2 以降)
export const ITEM_TYPE = {
    NOT_SET: 0,
    COUPON: 1,
    TOURIST_INFO: 2
} as const;

export type ItemType = (typeof ITEM_TYPE)[keyof typeof ITEM_TYPE];

export const ACCOUNT_TYPE = {
    GOOGLE: 'GOOGLE',
    TWITTER: 'TWITTER',
    LINE: 'LINE',
    PASSKEY: 'PASSKEY'
} as const;

export type AccountType = (typeof ACCOUNT_TYPE)[keyof typeof ACCOUNT_TYPE];

export const ITEM_STATUS = {
    UN_PUBLISHED: 0,
    PUBLISHED: 1,
    PRIVATE: 2
} as const;

export type ItemStatus = (typeof ITEM_STATUS)[keyof typeof ITEM_STATUS];

export const ITEM_ACTIVITY = {
    NONE: 1,
    PUBLISHED__ON_MAP: 2,
    PUBLISHED__GET_IT: 3,
    PUBLISHED__USED: 4,
    PUBLISHED__RESTORE: 5,
    PRIVATE__REPORT: 6,
    PRIVATE__WITHDRAWAL: 7,
    PRIVATE__EXPIRED: 8
} as const;

export type ItemActivity = (typeof ITEM_ACTIVITY)[keyof typeof ITEM_ACTIVITY];
